import { h } from "preact";

/**
 * Сетка превью.
 * Masonry не нужен — используем aspect-ratio 1/1, всё ровно.
 */
export function Grid({ photos, onOpen }) {
  if (photos.length === 0) {
    return h("p", { class: "gallery__empty" }, "Нет фотографий в этой категории");
  }

  return h("div", { class: "gallery__grid" },
    photos.map((photo, index) =>
      h("button", {
        key: photo.src,
        type: "button",
        class: "gallery__item",
        onClick: () => onOpen(index),
        "aria-label": `Открыть фото: ${photo.title || photo.alt}`,
      },
        h("img", {
          src: photo.thumb || photo.src,
          alt: photo.alt,
          loading: "lazy",
          decoding: "async",
          width: photo.width,
          height: photo.height,
        }),
        photo.title && h("span", { class: "gallery__item-label" }, photo.title)
      )
    )
  );
}
